import React, { useState } from 'react';
import { Button, InputNumber, Modal, Card, Col, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { selectors, breakDeposit, DepositInstrument, makeDeposit } from 'state';
import { formatters } from 'services';
import { selectedPerson } from '../../../../state/app/selectors';
import { AreaChart } from 'components';
import { add } from 'lodash';

type Props = {
  visible: boolean;
  hide: () => void;
};

const BenchmarkPreviewModal: React.FC<Props> = ({ visible, hide }) => {
  const session = useSelector(selectors.activeSession);
  // const benchmarkData = [{ x: 0, y: 0 }];
  const benchmarkData = session.bechmark_preview_new.composite.map(
    (item, index) => ({
      x: index * session.frequency + 1,
      y: item,
    })
  );

  const comps = session.bechmark_preview_new.components;
  const additionalLines = [];
  if (Object.keys(comps).length > 1) {
    for (const [key, val] of Object.entries(comps)) {
      const compLine = val.values.map((item, index) => ({
        x: index * session.frequency + 1,
        y: item,
      }));
      additionalLines.push({ data: compLine, name: key });
    }
  }

  //   additionalLines={[
  //       { data: close_series, name: 'close' },
  //   { data: ask_series, name: 'ask' },
  // ]}

  const xaxis = {
    tooltip: {
      enabled: false,
    },
    labels: {
      formatter: function (value: unknown) {
        return `Day ${value}`;
      },
      show: false,
    },
  };
  return (
    <Modal
      open={visible}
      onCancel={hide}
      title={`Benchmark preview for ${session.start_date.split('T')[0]} to ${
        session.end_date.split('T')[0]
      }`}
      footer={
        [
          /* leave empty to delete ok cancel buttons*/
        ]
      }
    >
      <AreaChart
        title=""
        dataSeriesName="Benchmark preview"
        data={benchmarkData}
        yaxisFormatter={formatters.percent1Digit}
        xaxis={xaxis}
        // tooltipDateFormat={'d MMM HH:mm'}
        {...(additionalLines.length > 0 ? { additionalLines } : {})}
      />
    </Modal>
  );
};

export default BenchmarkPreviewModal;
